import { postMindmapListDir } from "../../../common/netWork/mind_map_api";

class MindFilesAnalyze {

    constructor(files) {
        this.mindMapFiles = []
        this.mindFolders = []
        this.allFiles = files
    }
    
    loadAllData() {
        if (this.allFiles != null && this.allFiles.length > 0) {
            this.loadChildFiles();
            return;
        }
        this.allFiles = []
        let that = this
        this.pullMind( "", (res) => {
            that.allFiles = res.entities
            setTimeout(() => {
                that.loadChildFiles()
            }, 50);
            console.log("res.entities-", res.entities);            
          }, () => {
            console.log("load fail");  
          } )
    }

    loadChildFiles(complete) {
        let that = this
        var isLoadComplete = true
        for (let index = 0; index < this.allFiles.length; index++) {
            const cell = this.allFiles[index];
            if (cell.isDir) {
                if ((cell.isLoaded == null || !cell.isLoaded)) {
                    this.pullMind(cell.id, (res) => {                    
                        cell.childs = res.entities
                        cell.isLoaded = true
                        setTimeout(() => {
                            that.loadChildFiles()
                        }, 100);
                        console.log("load cell ", res.entities)
                    }, () => { console.log("load fail: ", cell.id) })
                    isLoadComplete = false
                    break
                } else if (cell.childs != null) {
                    for (let i = 0; i < cell.childs.length; i++) {
                        const child = cell.childs[i]
                        if (child.isDir) {
                            if ((child.isLoaded == null || !child.isLoaded)) {
                                this.pullMind(child.id, (res) => {                    
                                    child.childs = res.entities
                                    child.isLoaded = true
                                    setTimeout(() => {
                                        that.loadChildFiles()
                                    }, 100);
                                    console.log("load child ", res.entities)                                    
                                }, () => { console.log("load fail: ", child.id) })
                                isLoadComplete = false
                                break
                            }
                        }
                    }
                }
            }
        }
        if (isLoadComplete) {
            console.log("load complete ", this.formatAnalyzeText());    
            if (complete) {
                complete()
            }        
        }
    }

    formatAnalyzeText() {
        let josArr = []
        for (let index = 0; index < this.allFiles.length; index++) {
            const cell = this.allFiles[index];
            josArr.push(this.formatDataForAnalyze(cell))
        }
        let json = JSON.stringify(josArr, function (key, val) {
            if (typeof val === "function") {
                return val + '';
            }
            return val
        });
        return json
    }

    formatDataForAnalyze(cell) {
        let jsonObj = {name: cell.name, createTime: cell.createTime, modifyTime: cell.modifyTime}
        if (cell.isDir) {
            jsonObj.isDir = true
            var childs = []
            if (cell.childs && cell.childs.length > 0) {
                for (let index = 0; index < cell.childs.length; index++) {
                    childs.push(this.formatDataForAnalyze(cell.childs[index]))
                }
            }
            jsonObj.childs = childs
        } else {
            if (cell.subtitle && cell.subtitle.length > 20) {
                jsonObj.subtitle = cell.subtitle.substring(20)
            } else {
                jsonObj.subtitle = cell.subtitle
            }
        }
        return jsonObj
    }

    pullMind(parentId, onOk, onFail) {
      //拉取文件夹下的文件
      let that = this;
      postMindmapListDir(
        { parentId: parentId },
        (res) => {
          onOk(res);
        },
        (error) => {
          if (onFail) {
            onFail(error);
          }
        },
        () => {
        }
      );
    }
}
export default MindFilesAnalyze